import React from 'react';

import HelpMenu from './HelpMenu';
import NavigationMenu from './NavigationMenu';
import UserMenu from './UserMenu';
import Breadcrumbs from './Breadcrumbs';
import Access from './types/Access';
import Domains from './types/Domains';
import LinkHandler from './types/LinkHandler';
import User from './types/User';

import '../../../src/styles/variables.css';
import './ApplicationHeader.css';

const defaultProps = {
  user: null,
  context: null,
};

export type Props = {
  access: Access,
  context: React.ReactNode,
  domains: Domains,
  onClickLink: LinkHandler,
  organizationName?: string,
  productName?: string,
  user?: User,
  links?: Record<string, string>,
};

class ApplicationHeader extends React.Component<Props> {
  hasConfiguredChat = false;

  constructor(props: Props) {
    super(props);
    this.hasConfiguredChat = false;
    this.onClickChat = this.onClickChat.bind(this);
  }

  componentDidUpdate() {
    this.configureChat();
  }

  onClickChat(
    event: React.MouseEvent,
    close?: () => void,
  ): void {
    this.setChatVisibility(true);
    close && close();
  }

  setChatVisibility(isVisible: boolean) {
    window.document.body.classList.toggle('intercom--show', isVisible);
    // @ts-ignore
    if (isVisible) window.Intercom('show');
  }

  configureChat() {
    // @ts-ignore
    if (!this.hasConfiguredChat && window.Intercom) {
      // Set up a few toggling classes to show/hide Intercom's UI based on customer action
    // @ts-ignore
      window.Intercom('onShow', this.setChatVisibility.bind(this, true));
    // @ts-ignore
      window.Intercom('onHide', this.setChatVisibility.bind(this, false));
      // Show Intercom's UI when we push messages to them (or respond)
    // @ts-ignore
      window.Intercom('onUnreadCountChange', (unreadCount) => {
    // @ts-ignore
        if (unreadCount > 0) window.Intercom('showMessages');
      });
      this.hasConfiguredChat = true;
    }
  }

  render() {
    const {
      onClickLink,
      productName,
      organizationName,
      context,
      user,
      access,
      domains,
    } = (this.props as Props);
    return (
      <div
        id="ApplicationHeader"
        className="ApplicationHeader"
      >
        <NavigationMenu
          onClickLink={onClickLink}
          productName={productName}
          access={access}
          domains={domains}
          links={this.props.links}
        />
        <div className="ApplicationHeader-content">
          <div className="ApplicationHeader-contextual">
            {(
              context
                ? context
                : <span className="ApplicationHeader-organizationTitle">{organizationName}</span>
            )}
          </div>
          <div className="ApplicationHeader-supporting">
            <HelpMenu
              onClickLink={onClickLink}
              access={access}
              domains={domains}
              onClickChat={this.onClickChat}
            />
            <UserMenu
              onClickLink={onClickLink}
              access={access}
              domains={domains}
              user={user}
            />
          </div>
        </div>
      </div>
    );
  }

  static defaultProps = defaultProps;
  static Breadcrumbs = Breadcrumbs;
  static displayName = 'ApplicationHeader';
}

export default ApplicationHeader;
